import React, { Component } from "react";
import { Layout } from "antd";
import { connect } from "react-redux";
import { logoutAction } from "../login/loginActions";

import TopNav from "./TopNav";

const { Header } = Layout;
class AppHeader extends Component {
  render() {
    const { hideExtraTopNavOptions } = this.props;
    return (
      <Header>
        <TopNav
          changeLanguage={this.props.changeLanguage}
          currentLanguage={this.props.currentLanguage}
          currentPage={this.props.currentPage}
          hideExtraTopNavOptions={hideExtraTopNavOptions}
          logout={this.props.logout}
        />
      </Header>
    );
  }
}

const mapStateToProps = state => {
  return {
    isProcessing: state.login.isProcessing
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logoutAction)
  };
};

const connectedPage = connect(mapStateToProps, mapDispatchToProps)(AppHeader);
export { connectedPage as AppHeader };
